/*
 * @Author: hai.zhang
 * @LastEditors: hai.zhang
 * @Date: 2020-12-24 19:30:59
 * @LastEditTime: 2020-12-28 15:36:15
 */
import state from './state'
import mutation from './mutation'
import action from './action'

const store = {
  state: {
    ...state
  },
  mutations: {
    ...mutation
  },
  actions: {
    ...action
  }
}

export default store
